import React, { Fragment } from 'react';

export const isEmailValid = (email) => {
  /* prettier-ignore */
  // eslint-disable-next-line
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const getEmailDomain = (email) => email.substring(email.indexOf('@') + 1);

const escapeRE = /([.*+?^=!:$(){}|[\]/\\])/g;
export const safeRE = (s, opts) => {
  return new RegExp(s.replace(escapeRE, '\\$1'), opts);
};

export const textWithHighlight = (text, searchTerm) => {
  if (!searchTerm) return text;
  return text?.split(searchTerm).map((element, index, arr) => (
    <Fragment key={element}>
      {element}
      {index !== arr.length - 1 && <b>{searchTerm}</b>}
    </Fragment>
  ));
};

/**
 * Mainly used to sort questions by 'sort' column.
 * This is needed since ordering isn't guaranteed from backend -> frontend.
 */
export const sortQuestionsBySortColumn = (questions) => {
  if (!questions || questions.length === 0) return [];

  return [...questions].sort((a, b) => {
    if (a.sort !== undefined && b.sort !== undefined) {
      return a.sort - b.sort;
    }
    return 0;
  });
};

export const getGuestStatusFilterOption = ({
  hasPreEventQuestionsQuestions,
  hasUnlimitedSpots,
  guestHasNoneStatus = false
}) => {
  return [
    'Going',
    ...(hasPreEventQuestionsQuestions ? ['Incomplete'] : []),
    // TOOD: Filter out waitlisted per session level by looking at limited spots.
    'Waitlisted',
    'Maybe',
    'Not going',
    'Pending',
    'Invited',
    ...(guestHasNoneStatus ? ['None'] : [])
  ];
};
